<template>
  <header class="fixed top-0 left-0 right-0 h-14 bg-primary z-[999] flex items-center justify-between px-4 shadow-md">
    <!-- Left: Menu toggle -->
    <button v-if="user" @click="onMenuToggle"
      class="w-10 h-10 rounded-lg flex items-center justify-center text-white/90 hover:bg-white/10 transition-colors">
      <i class="pi pi-bars text-lg"></i>
    </button>

    <!-- Right: Actions -->
    <div v-if="user" class="flex items-center gap-1">
      <button class="relative w-10 h-10 rounded-lg flex items-center justify-center text-white/90 hover:bg-white/10 transition-colors">
        <i class="pi pi-calendar text-lg"></i>
        <span class="absolute -top-0.5 -right-0.5 w-4 h-4 bg-red-500 text-[10px] text-white font-bold rounded-full flex items-center justify-center">5</span>
      </button>
      <button class="w-10 h-10 rounded-lg flex items-center justify-center text-white/90 hover:bg-white/10 transition-colors">
        <i class="pi pi-cog text-lg"></i>
      </button>
      <button @click="handleLogout"
        class="w-10 h-10 rounded-lg flex items-center justify-center text-white/90 hover:bg-white/10 transition-colors">
        <i class="pi pi-sign-out text-lg"></i>
      </button>
    </div>
  </header>
</template>

<script setup>
import useUser from '@/composables/useUser';
import useLogout from '@/composables/useLogout';
import { useRouter } from 'vue-router';

const { user } = useUser();
const { logout } = useLogout();
const router = useRouter();

const emit = defineEmits(['menu-toggle']);

const onMenuToggle = (event) => {
  emit('menu-toggle', event);
};

const handleLogout = async () => {
  await logout();
  router.push({ name: 'Home' });
  location.reload();
};
</script>
